import PropTypes from 'prop-types';
import React from 'react';
import Browser from '@wetransfer/concorde-browser';

import Icon from '@component/icon';

function makeItems(items, props) {
  return items.map((item) => {
    if (item.hidden) {
      return;
    }

    const active = item.href === props.activeItem;
    const className = ['verticalnav__item'];
    let arrow = null;
    let anchors = null;
    let rel = null;

    if (active) {
      className.push('verticalnav__item--active');
      arrow = !Browser.isMobile
        ? React.createElement(
            'span',
            { key: item.href, className: 'verticalnav__arrow' },
            <Icon type="Arrow" color="#17181A" />
          )
        : null;

      if (item.anchors) {
        className.push('verticalnav__item--has-subitems');
        anchors = (
          <ul className="verticalnav__list">
            {makeItems(item.anchors, props)}
          </ul>
        );
      }
    }

    if (item.external) {
      className.push('verticalnav__item--is-external');
      rel = 'external';
    }

    // Not sure whether we should real anchors or onClick events for this
    let label = null;
    if (item.href) {
      label = React.createElement('a', { href: item.href, rel }, item.label);
    } else {
      label = React.createElement('p', null, item.label);
      className.push('verticalnav__item--is-only-label');
    }

    const onClick = props.onClick ? () => props.onClick(item.href) : null;

    if (item.className) {
      className.push(item.className);
    }

    return React.createElement(
      'li',
      {
        key: item.href || item.label,
        className: className.join(' '),
        onClick,
      },
      arrow,
      label,
      item.icon,
      anchors
    );
  });
}

const VerticalNav = (props) => {
  const className = ['verticalnav'];

  if (props.className) {
    className.push(props.className);
  }

  if (props.sticky) {
    className.push('verticalnav--is-sticky');
  }

  return (
    <nav className={className.join(' ')}>
      <ul className="verticalnav__list">{makeItems(props.items, props)}</ul>
      {props.children}
    </nav>
  );
};

VerticalNav.propTypes = {
  items: PropTypes.array,
  className: PropTypes.string,
  activeItem: PropTypes.string,
  onClick: PropTypes.func,
  sticky: PropTypes.bool,
  children: PropTypes.any,
};

VerticalNav.defaultProps = {
  className: null,
  sticky: false,
};

export default VerticalNav;
